var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{attrs:{"value":!_vm.isPrivate,"ok-label":_vm.$t('rooms.public'),"ko-label":_vm.$t('rooms.private')}})}
var staticRenderFns = []

export { render, staticRenderFns }